<template>
  <div class="form-radio-group">
    <h4>{{label}}</h4>
    <div class="form-radio-wrapper" v-for="option in options" v-bind:key="option.value">
      <input type="radio"
            :id="`${groupName}_${option.value}`"
            :name="groupName"
            :value="option.value"
            v-on:input="$emit('input', $event.target.value)"
            :checked="value == option.value" required>
      <label :for="`${groupName}_${option.value}`">{{option.text}}</label>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'value',
    'label',
    'options',
    'groupName',
  ],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
  .form-radio-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    input[type=radio] {
      width: auto;
      margin-right: 1rem;
    }
  }
</style>
